const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function sendContact(kind, name, email, extra = {}) {
  const res = await fetch(`${API}/contact/${kind}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, extra }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Request failed");
  }
  return res.json();
}
